// A number FleetControl writes without its leading zero (":.0009", ", -.5"), right after ':', ',' or '['
const NUMBER_WITHOUT_LEADING_ZERO = /([:,[]\s*)(-?)\.(\d)/g;

/**
 * Parses a FleetControl web service body that axios left as text because it is not valid JSON.
 * SQL Anywhere writes a decimal below 1 as ".0009" (ws_MyWayStudio_Get_Client_Budget, found 2026-11-01),
 * which JSON.parse refuses. Only a body that fails as it is gets the leading zeros added; an object, valid
 * JSON and text that is not JSON at all come back unchanged.
 */
export const parseFcJson = <T = unknown>(body: unknown): T | unknown => {
    if (typeof body !== 'string') return body;
    try {
        return JSON.parse(body) as T;
    } catch {
        try {
            return JSON.parse(body.replace(NUMBER_WITHOUT_LEADING_ZERO, '$1$20.$3')) as T;
        } catch {
            return body;
        }
    }
};
